export default __webpack_public_path__ + "static/media/gl.e915d859.svg";